<template>
  <el-container id="dragpanel">
    <el-header style="height: 36px">
      <div @mousedown="mousedown">
        <span>{{title}}</span>
        <div @click="closeDialog" class="btn-close">
          <i class="el-icon-close closeicon"></i>
        </div>
      </div>
    </el-header>
    <el-main>
      <slot>这里是内容</slot>
    </el-main>
  </el-container>
</template>

<script>
  export default {
    name: 'DragPanel',
    props: {
      title: {
        type: String,
        default: '地块信息'
      }
    },
    data() {
      return {
        selectElement: ''
      }
    },
    computed: {
      
    },
    methods: {
      closeDialog() {
        this.$parent.handleClose()
      },
      mousedown(event) {
        this.selectElement = document.getElementById('dragpanel')
        var div1 = this.selectElement
        this.selectElement.style.cursor = 'move'
        this.isDowm = true
        var distanceX = event.clientX - this.selectElement.offsetLeft
        var distanceY = event.clientY - this.selectElement.offsetTop
        // alert(distanceX)
        // alert(distanceY)
        // console.log(distanceX)
        // console.log(distanceY)
        document.onmousemove = function (ev) {
          var oevent = ev || event
          div1.style.left = oevent.clientX - distanceX + 'px'
          div1.style.top = oevent.clientY - distanceY + 'px'
        }
        document.onmouseup = function () {
          document.onmousemove = null
          document.onmouseup = null
          div1.style.cursor = 'default'
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.el-container {
  position: absolute;
  width: 420px;
  top: 10px;
  left: 320px;
  border-radius: 2px;
  background: rgba(7, 17, 41, 0.9);
  overflow-y: auto;
  z-index: 10;
}
.el-header {
  background: linear-gradient(90deg, rgba(40, 153, 255, 0.5), rgba(57, 68, 121, 0.3));
  color: #fff;
  line-height: 36px;
  font-size: 16px;
  font-family: SourceHanSansCN-Medium;
  font-weight: 600;
  cursor: move;
}
.el-main {
  padding: 6px 16px;
  max-height: calc(100vh - 160px);
  overflow-y: auto;
}
.btn-close {
  position: absolute;
  top: 2px;
  right: 10px;
  color: #fff;
  cursor: pointer;
  .closeicon {
    font-size: 18px;
  }
}
</style>